function formatNumber(value, numberLocale) {
    return value.toLocaleString(numberLocale);
}

export { formatNumber };
